import {WeaTools} from 'ecCom';

// 获取主题
export const getMyTheme = (params = {}) => WeaTools.callApi('/api/portal/themeCenter/getMyTheme', 'GET', params);
// 获取主题配置
export const getThemeConfig = (params = {}) => WeaTools.callApi('/api/portal/themeConfig/getThemeConfig', 'GET', params);
// 获取插件
export const getPlugins = (params = {}) => WeaTools.callApi('/api/portal/plugin/getPlugins', 'GET', params);
// 获取前端菜单
export const getFrontEndMenu = (params = {}) => WeaTools.callApi('/api/portal/menu/getFrontEndMenu', 'GET', {withPortal: '1', isLoadAll: '1', ...params});
// 获取后端菜单
export const getBackEndMenu = (params = {}) => WeaTools.callApi('/api/portal/menu/getBackEndMenu', 'GET', params);
// 获取顶部菜单
export const getTopMenu = (params = {}) => WeaTools.callApi('/api/portal/menu/getFrontEndMenu', 'GET', {withPortal: '1', isLoadAll: '0', ...params});
// 获取门户菜单
export const getPortalMenu = (params = {}) => WeaTools.callApi('/api/portal/menu/getPortalMenu', 'GET', params);
// 获取邮件菜单
export const getEmailMenu = (params = {}) => WeaTools.callApi('/api/portal/emailmenu/emailmenu', 'POST', params);
// 获取模块菜单
export const getModuleMenu = (params = {}) => WeaTools.callApi('/api/portal/leftmenu/leftmenu', 'POST', params);
// 获取常用菜单
export const getFreqUseMenu = (params = {}) => WeaTools.callApi('/api/portal/frequsemenu/getdata', 'POST', { parentid: 0 });
// export const getFreqUseMenu = (params = {}) => WeaTools.callApi('/api/portal/frequsemenu/frequsemenu', 'POST', {shownourlmenu: 'n', ...params});
// 获取快速搜索类型
export const getQuickSearchTypes = (params = {}) => WeaTools.callApi('/api/portal/quickSearch/getQuickSearchTypes', 'GET', params);
// 获取快速搜索路由
export const getQuickSearchRoute = (params = {}) => WeaTools.callApi('/api/fullsearch/base/getQuickSearchRoute', 'POST', params);
// 获取微搜联想推荐
export const getWsAssociate = (params = {}) => WeaTools.callApi('/api/fullsearch/base/getAssociate', 'POST', params);
// 获取消息中心数量
export const getRemindCount = (params = {}) => WeaTools.callApi('/api/msgcenter/homepage/getMsgCount', 'GET', params);
// 获取工具栏菜单
export const getToolbarMenu = (params = {}) => WeaTools.callApi('/api/portal/toolbar/getToolbarMenu', 'GET', params);
// 获取工具栏更多菜单
export const getToolbarMoreMenu = (params = {}) => WeaTools.callApi('/api/portal/toolbarMore/getToolbarMoreMenu', 'GET', {menutype: 'front', ...params});
// 获取账号信息
export const getAccount = (params = {}) => WeaTools.callApi('/api/portal/account/getAccount', 'GET', params);
// 获取账号菜单
export const getAccountMenu = (params = {}) => WeaTools.callApi('/api/portal/account/getAccountMenu', 'GET', {menutype: 'front', ...params});
// 获取账号更多菜单
export const getAccountMoreMenu = (params = {}) => WeaTools.callApi('/api/portal/accountmore/getAccountMoreMenu', 'GET', {menutype: 'front', ...params});
// 设置顶部菜单点击次数
export const setTopMenuStatictics = (params = {}) => WeaTools.callApi('/api/portal/menu/setTopMenuStatictics', 'POST', params);
// 设置主题
export const setMyTheme = (params = {}) => WeaTools.callApi('/api/portal/themeCenter/setMyTheme', 'POST', params);
// 设置特色门户主题
export const setMyThemeTs = (params = {}) => WeaTools.callApi('/api/portal/themeCenter/setMyThemeTs', 'POST', params);
// 设置主题颜色
export const setMyThemeColor = (params = {}) => WeaTools.callApi('/api/portal/themeCenter/setMyThemeColor', 'POST', params);
// 设置主题布局
export const setMyThemeLayout = (params = {}) => WeaTools.callApi('/api/portal/themeCenter/setMyThemeLayout', 'POST', params);
// 设置字体大小
export const setMyFontSize = (params = {}) => WeaTools.callApi('/api/portal/themeCenter/setMyFontSize', 'POST', params);
// 切换多语言
export const changeLang = (params = {}) => WeaTools.callApi('/api/system/language/base/changeLang', 'GET', params);
// 设置快捷搜索栏是否显示搜索推荐
export const setQuickSearchShowRcmd = (params = {}) => WeaTools.callApi('/api/portal/customSetting/setQuickSearchShowRcmd', 'POST', params);
// 获取门户向导信息
export const getPortalIntroInfo = (params = {}) => WeaTools.callApi('/api/portal/portalintro/getdata', 'POST', params);
// 设置门户向导信息
export const setPortalIntroInfo = (params = {}) => WeaTools.callApi('/api/portal/portalintro/save', 'POST', params);


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/apis/theme.js